export default {
    announcements: [{ id: 1, text: 'This is a test announcement' }],
    screen: {
        area: {
            id: 1,
            nameEl: 'Θεσσαλονίκη',
            nameEn: 'THESSALONIKI PASSENGER'
        }
    },
    routes: [
        {
            routesEl: {
                PREVIOUSDELAY9: '9',
                DR_DELAYCODE: null,
                DR_TANA: ' 13.42',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 6026, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '2',
                RUP: 'ΣΤΑΣΥ ΑΕ',
                TRENO: '6026 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: "9'-Παιανία - Κάντζα-ΥΠΕΡΒΑΣΗ ΤΟΥ ΧΡΟΝΟΥ ΣΤΑΣΗΣ",
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 13:51',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 13.42',
                FROMTO: 'Διακλάδωση Μετρό M3-Αεροδρόμιο'
            },
            routesEn: {
                PREVIOUSDELAY9: '9',
                DR_DELAYCODE: null,
                DR_TANA: ' 13.42',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 6026, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '2',
                RUP: 'ΣΤΑΣΥ ΑΕ',
                TRENO: '6026 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: "9'-Παιανία - Κάντζα-ΥΠΕΡΒΑΣΗ ΤΟΥ ΧΡΟΝΟΥ ΣΤΑΣΗΣ",
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 13:51',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 13.42',
                FROMTO: 'Διακλάδωση Μετρό M3-Αεροδρόμιο    '
            }
        },
        {
            routesEl: {
                PREVIOUSDELAY9: '0',
                DR_DELAYCODE: null,
                DR_TANA: ' 13.52',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 2235, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '1',
                RUP: 'HELLENIC TRAIN',
                TRENO: '2235 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: null,
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 13:52',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 13.52',
                FROMTO: 'Αεροδρόμιο-Ανω Λιόσια'
            },
            routesEn: {
                PREVIOUSDELAY9: '0',
                DR_DELAYCODE: null,
                DR_TANA: ' 13.52',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 2235, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '1',
                RUP: 'HELLENIC TRAIN',
                TRENO: '2235 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: null,
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 13:52',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 13.52',
                FROMTO: 'Διακλάδωση Μετρό M3-Αεροδρόμιο    '
            }
        },
        {
            routesEl: {
                PREVIOUSDELAY9: '0',
                DR_DELAYCODE: null,
                DR_TANA: ' 13.58',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 6027, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '2',
                RUP: 'ΣΤΑΣΥ ΑΕ',
                TRENO: '6027 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: null,
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 13:58',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 13.58',
                FROMTO: 'Αεροδρόμιο-Διακλάδωση Μετρό M3'
            },
            routesEn: {
                PREVIOUSDELAY9: '0',
                DR_DELAYCODE: null,
                DR_TANA: ' 13.58',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 6027, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '2',
                RUP: 'ΣΤΑΣΥ ΑΕ',
                TRENO: '6027 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: null,
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 13:58',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 13.58',
                FROMTO: 'Αεροδρόμιο-Διακλάδωση Μετρό M3'
            }
        },
        {
            routesEl: {
                PREVIOUSDELAY9: '15',
                DR_DELAYCODE: null,
                DR_TANA: ' 13.49',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 1218, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '1',
                RUP: 'HELLENIC TRAIN',
                TRENO: '1218 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: "15'-Νερατζίωτισσα-ΥΠΕΡΒΑΣΗ ΤΟΥ ΧΡΟΝΟΥ ΣΤΑΣΗΣ",
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 14:04',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 13.49',
                FROMTO: 'Πειραιάς-Αεροδρόμιο'
            },
            routesEn: {
                PREVIOUSDELAY9: '15',
                DR_DELAYCODE: null,
                DR_TANA: ' 13.49',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 1218, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '1',
                RUP: 'HELLENIC TRAIN',
                TRENO: '1218 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: "15'-Νερατζίωτισσα-ΥΠΕΡΒΑΣΗ ΤΟΥ ΧΡΟΝΟΥ ΣΤΑΣΗΣ",
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 14:04',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 13.49',
                FROMTO: 'Πειραιάς-Αεροδρόμιο'
            }
        },
        {
            routesEl: {
                PREVIOUSDELAY9: '2',
                DR_DELAYCODE: null,
                DR_TANA: ' 14.04',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 2230, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '1',
                RUP: 'HELLENIC TRAIN',
                TRENO: '2230 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: "2'-Νερατζίωτισσα-ΥΠΕΡΒΑΣΗ ΤΟΥ ΧΡΟΝΟΥ ΣΤΑΣΗΣ",
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 14:06',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 14.04',
                FROMTO: 'Ανω Λιόσια-Αεροδρόμιο'
            },
            routesEn: {
                PREVIOUSDELAY9: '2',
                DR_DELAYCODE: null,
                DR_TANA: ' 14.04',
                DR_NEXTDAYP: null,
                DR_FREEDESC: 'Message of Train 2230, ',
                DR_STATHMOSP: 'Αεροδρόμιο',
                DR_STATHMOS: 'ΠΑΕΡ',
                DR_PLATFORM: '1',
                RUP: 'HELLENIC TRAIN',
                TRENO: '2230 ',
                DR_DELAY_AFIX: null,
                PREVIOUSDELAY: "2'-Νερατζίωτισσα-ΥΠΕΡΒΑΣΗ ΤΟΥ ΧΡΟΝΟΥ ΣΤΑΣΗΣ",
                DROPTIONAL: null,
                PASSENGER_FREIGHTS: 'PASSENGERS',
                DR_FORECASTED_DATE: '31/07/2024 14:06',
                DR_DELAY_TANA: null,
                STATIONAA: '28',
                DR_TAFIX: ' 14.04',
                FROMTO: 'Ανω Λιόσια-Αεροδρόμιο'
            }
        }
    ]
}
